import React from 'react';
import styled from 'styled-components/macro';
import Footer from '../Footer/Footer';

const LegalsContainer = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 160px;
  margin-bottom: 80px;
`;
const LegalsText = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding: 0 16px;
  font-family: Lato;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  text-align: left;
  line-height: 23px;
  max-width: 500px;
  min-width: 310px;
  color: black;
  /* background: yellow; */
`;

const Legals = () => {
  return (
    <>
      <LegalsContainer>
        <LegalsText>
          Peter Frommann <br />
          Platenstraße 14, 50825 Köln
          <br />
          Verantwortlich: Peter Frommann
          <br />
          email: info@peterfrommann.de
          <br />
          Haftungshinweis: Trotz sorgfältiger inhaltlicher Kontrolle übernehmen
          ich keine Haftung für die Inhalte externer Links. Für den Inhalt der
          verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
          <br /> Alle Rechte vorbehalten. Texte und Bilder unterliegen dem
          Schutz des Urheberrechts und anderer Schutzgesetze. Der Inhalt dieser
          Webseite darf nicht zu kommerziellen Zwecken kopiert, verbreitet,
          verändert oder Dritten zugänglich gemacht werden.
          <br />
          Copyright 2020 by Peter Frommann
        </LegalsText>
      </LegalsContainer>
      <Footer />
    </>
  );
};

export default Legals;
